import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import NoticesServices from "../../../services/NoticesService";
import moment from "moment";
import ScrollBarArea from "../../comum/components/ScrollBarArea";

@inject("store")
@inject("routes")
@observer
export default class Hero extends Component {
  constructor(props) {
    super(props);
    this.store = this.props.store;
    this.routes = this.props.routes;
    this.loginStore = this.props.store.loginStore;
    this.appStore = this.props.store.appStore;
    this.state = {
      notices: [],
    };
  }

  componentDidMount() {
    new NoticesServices().getHome().then(({ data }) => {
      if (data && Array.isArray(data) && data.length > 0) {
        this.setState({ notices: data });
      }
    });
  }

  render() {
    const { notices } = this.state;
    return (
      <div className="notices">
        {notices.map((notice) => (
          <span className="notice">
            <h1>
              <b>{notice.Title}</b>
            </h1>
            <div dangerouslySetInnerHTML={{ __html: notice.Body }}></div>
            <i>Postado em: {moment(notice.PublishAt).format("DD/MM/YYYY")}</i>
          </span>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/components/Hero.js